'use client';
import { styled } from '@mui/material/styles';
import { excludeComponentProps } from '../utils/excludeComponentProps';
import { getContainerMaxWidth } from '../helpers/getContainerMaxWidth';
export const HeaderContainer = styled('div', {
    ...excludeComponentProps('isContained')
})(({ theme, isContained }) => ({
    height: 'inherit',
    width: '100%',
    paddingInline: theme.tokens.FuelSpacing4,
    gap: theme.tokens.FuelSpacing6,
    display: 'flex',
    alignItems: 'center',
    maxWidth: getContainerMaxWidth(theme, isContained),
    ...isContained && {
        margin: '0 auto'
    }
}));
